module.exports = __webpack_public_path__ + "media/admin/cs_publication_003_lg-5b160db8.png";